import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import AboutPage from './pages/AboutPage';
import ModulesPage from './pages/ModulesPage';
import GamesHubPage from './pages/GamesHubPage';
import IdeaMatchGame from './pages/IdeaMatchGame';
import PricingChallengeGame from './pages/PricingChallengeGame';
import BudgetBuilderGame from './pages/BudgetBuilderGame';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/modules" element={<ModulesPage />} />
        <Route path="/games" element={<GamesHubPage />} />
        <Route path="/games/idea-match" element={<IdeaMatchGame />} />
        <Route path="/games/pricing-challenge" element={<PricingChallengeGame />} />
        <Route path="/games/budget-builder" element={<BudgetBuilderGame />} />
      </Routes>
    </Router>
  );
}

export default App;
